module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ISO 45001-2018.7e91cf51.png";